module.exports = __webpack_public_path__ + "media/components/publish/images/email_alert-b87e997c3190648af5d3ec7dff1422d4.png";